import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisablemfa = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M45.3125 1.5625H4.6875C2.96094 1.5625 1.5625 2.96094 1.5625 4.6875V34.375C1.5625 36.1016 2.96094 37.5 4.6875 37.5H11.7188C12.1484 37.5 12.5 37.1484 12.5 36.7188C12.5 36.2891 12.1484 35.9375 11.7188 35.9375H4.6875C3.82812 35.9375 3.125 35.2344 3.125 34.375V7.03125H30.2109L33.125 9.21875C33.2578 9.32031 33.4219 9.375 33.5938 9.375H46.875V34.375C46.875 35.2344 46.1719 35.9375 45.3125 35.9375H38.2812C37.8516 35.9375 37.5 36.2891 37.5 36.7188C37.5 37.1484 37.8516 37.5 38.2812 37.5H45.3125C47.0391 37.5 48.4375 36.1016 48.4375 34.375V4.6875C48.4375 2.96094 47.0391 1.5625 45.3125 1.5625ZM33.8516 7.8125L30.9375 5.625C30.8047 5.52344 30.6406 5.46875 30.4688 5.46875H3.125V4.6875C3.125 3.82812 3.82812 3.125 4.6875 3.125H45.3125C46.1719 3.125 46.875 3.82812 46.875 4.6875V7.8125H33.8516Z",
			fill: "#A4A4A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.9688 4.6875H41.4062C40.9766 4.6875 40.625 5.03906 40.625 5.46875C40.625 5.89844 40.9766 6.25 41.4062 6.25H42.9688C43.3984 6.25 43.75 5.89844 43.75 5.46875C43.75 5.03906 43.3984 4.6875 42.9688 4.6875Z",
			fill: "#A4A4A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.5 4.6875H35.9375C35.5078 4.6875 35.1562 5.03906 35.1562 5.46875C35.1562 5.89844 35.5078 6.25 35.9375 6.25H37.5C37.9297 6.25 38.2812 5.89844 38.2812 5.46875C38.2812 5.03906 37.9297 4.6875 37.5 4.6875Z",
			fill: "#A4A4A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8125 15.625H17.1875C15.4609 15.625 14.0625 17.0234 14.0625 18.75V45.3125C14.0625 47.0391 15.4609 48.4375 17.1875 48.4375H32.8125C34.5391 48.4375 35.9375 47.0391 35.9375 45.3125V18.75C35.9375 17.0234 34.5391 15.625 32.8125 15.625ZM34.375 45.3125C34.375 46.1719 33.6719 46.875 32.8125 46.875H17.1875C16.3281 46.875 15.625 46.1719 15.625 45.3125V18.75C15.625 17.8906 16.3281 17.1875 17.1875 17.1875H32.8125C33.6719 17.1875 34.375 17.8906 34.375 18.75V45.3125Z",
			fill: "#A4A4A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 28.5L23.5 31.5",
			stroke: "#A4A4A4",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 28.5L26.5 31.5",
			stroke: "#A4A4A4",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5625 42.1875H23.4375C23.0078 42.1875 22.6562 42.5391 22.6562 42.9688C22.6562 43.3984 23.0078 43.75 23.4375 43.75H26.5625C26.9922 43.75 27.3438 43.3984 27.3438 42.9688C27.3438 42.5391 26.9922 42.1875 26.5625 42.1875Z",
			fill: "#A4A4A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5 24.8359L25.25 22.6953C25.0859 22.6406 24.9062 22.6406 24.7422 22.6953L18.4922 24.8359C18.1797 24.9453 17.9609 25.2422 17.9609 25.5781V30.6563C17.9609 34.3906 20.1875 36.875 24.7656 38.25C24.8359 38.2734 24.9141 38.2812 24.9922 38.2812C25.0703 38.2812 25.1406 38.2734 25.2187 38.25C29.7969 36.875 32.0234 34.3906 32.0234 30.6563V25.5781C32.0234 25.2422 31.8125 24.9453 31.4922 24.8359H31.5ZM30.4688 30.6563C30.4688 33.6328 28.7812 35.5 25 36.6797C21.2188 35.4922 19.5313 33.625 19.5313 30.6563V26.1328L25 24.2578L30.4688 26.1328V30.6563Z",
			fill: "#A4A4A4"
		})
	]
});
const ForwardRef = forwardRef(SvgDisablemfa);
export default ForwardRef;
